<template lang="pug">
.statusbar__wrap(v-if="!isFirst")
  .statusbar
    .statusbar__values
      .statusbar__item(v-for='n in questionsLength')
        span.statusbar__el
    .statusbar__list
      .statusbar__item(
        v-for='n in questionsLength'
        :class="{ statusbar__item_active: (n - 1) <= activeQuestion.id, statusbar__item_current: n-1 === activeQuestion.id }"
        )
        span.statusbar__el {{ n }}
</template>
<script>
export default {
  name: 'StatusBar',
  props: {
    questionsLength: {
      type: Number,
      required: true
    },
    activeQuestion: {
      type: Object,
      required: true
    },
    isFirst: {
      type: Boolean,
      required: true
    }
  }
}
</script>
<style lang="stylus" scoped>
.statusbar
  max-width 1200px
  margin 0 auto
  height 2rem
  @media $tablet
    height 3rem
  &__wrap
    position relative
    width 100%
    height 2rem
    padding 0 2rem
    z-index: 9
    overflow hidden
    @media $tablet
      height 3rem
  &__values
    width 100%
    display flex
    align-items center
    justify-content space-between
    opacity 0.12
    &:before
      position absolute
      top 50%
      left -100rem
      right -100rem

      height 0.4rem

      background-color #4E4E4E
      transform translateY(-50%)
      content ''
      @media $tablet
        height 0.6rem
    .statusbar__item
      padding 0.3rem
      @media $tablet
        padding 0.5rem

  &__list
    position relative
    top -2rem

    width 100%
    display flex
    align-items center
    justify-content space-between
    @media $tablet
      top -3rem
    &:before
      position absolute
      top 50%
      left -100rem
      width 100rem
      height 0.4rem
      background-color $blue
      transform translateY(-50%)
      content ''
      @media $tablet
        height 0.6rem

    .statusbar__item
      position relative
      opacity 0
      transition opacity 0.6s ease
      .statusbar__el
        position relative
        z-index 3
      &:before
        position absolute
        top 50%
        right 0
        width 30rem
        height 0.4rem
        background-color $blue
        transform translateY(-50%)
        content ''
        @media $tablet
          height 0.6rem

      &_active
        opacity 1
      for num in (1...20)
        &:nth-child({20 - num})
          z-index num

  &__item
    width 2rem
    height 2rem
    @media $tablet
      width 3rem
      height 3rem
    &_active
      padding: 0.5rem
      .statusbar__el
        background-color: $blue
        color: #0942e2
        box-shadow: 0 1px 4px 0 rgba(0,0,0,0.50)
    &_current
      padding: 0
      .statusbar__el
        color: #fff
        background-color: $blue
        border-color #000


  &__el
    display flex
    width 100%
    height 100%
    border: 1px solid transparent
    align-items center
    justify-content center

    font-weight 500
    font-size: 1.2rem
    color: #FFFFFF
    line-height 2rem
    letter-spacing: -0.15px
    white-space: nowrap

    background-color #4E4E4E
    border-radius 50%
    @media $tablet
      border-width 2px

      font-size 1.6rem
      line-height 1
</style>

